// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {Procedure} from './Procedure';
import {SampleEventPhase} from './SampleEventPhase';
import {SampleEventStaff} from './SampleEventStaff';
import {SampleEventType} from './SampleEventType';

const _associations = [
			{
				name: 'Procedure',
				model: new Procedure(),
				type: 'ParentPointer',
				using: 'procedureId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Procedure',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SampleEventPhase',
				model: new SampleEventPhase(),
				type: 'ParentPointer',
				using: 'sampleEventPhaseId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SampleEventPhase',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SampleEventStaff',
				model: new SampleEventStaff(),
				type: 'ArrayOfChildren',
				using: 'sampleEventId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SampleEventStaff',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SampleEventType',
				model: new SampleEventType(),
				type: 'ParentPointer',
				using: 'sampleEventTypeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SampleEventType',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'conservationActionSampleEventId',
				placeholder: null,
				key: 'conservationActionSampleEventId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.conservationActionSampleEventId,
				setter: (x, y) => x.conservationActionSampleEventId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'conservationActionId',
				placeholder: null,
				key: 'conservationActionId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.conservationActionId,
				setter: (x, y) => x.conservationActionId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'conservationActionPhaseId',
				placeholder: null,
				key: 'conservationActionPhaseId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.conservationActionPhaseId,
				setter: (x, y) => x.conservationActionPhaseId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'sampleEventId',
				placeholder: null,
				key: 'sampleEventId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.sampleEventId,
				setter: (x, y) => x.sampleEventId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'sampleEventTypeId',
				placeholder: null,
				key: 'sampleEventTypeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.sampleEventTypeId,
				setter: (x, y) => x.sampleEventTypeId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Sample Event Phase',
				placeholder: null,
				key: 'sampleEventPhaseId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 1,
				getter: (x) => x.sampleEventPhaseId,
				setter: (x, y) => x.sampleEventPhaseId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'SampleEventPhaseServiceViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Other Purpose',
				placeholder: null,
				key: 'otherPurpose',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 4,
				getter: (x) => x.otherPurpose,
				setter: (x, y) => x.otherPurpose = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Procedure',
				placeholder: null,
				key: 'procedureId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 3,
				getter: (x) => x.procedureId,
				setter: (x, y) => x.procedureId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'ProcedureServiceViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Procedure',
				placeholder: null,
				key: 'environmentalBenefitId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 2,
				getter: (x) => x.environmentalBenefitId,
				setter: (x, y) => x.environmentalBenefitId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'EnvironmentalBenefitServiceViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'MobileSampleEvent ID',
				placeholder: null,
				key: 'mobileSampleEventId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.mobileSampleEventId,
				setter: (x, y) => x.mobileSampleEventId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'MobileSampleEventLog ID',
				placeholder: null,
				key: 'mobileSampleEventLogId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.mobileSampleEventLogId,
				setter: (x, y) => x.mobileSampleEventLogId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'description',
				placeholder: null,
				key: 'description',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.description,
				setter: (x, y) => x.description = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Start Date',
				placeholder: null,
				key: 'startDate',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 5,
				getter: (x) => x.startDate,
				setter: (x, y) => x.startDate = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateTimeFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
					format: 'MMMM d, yyyy',
				}
			},
			{
				title: 'End Date',
				placeholder: null,
				key: 'endDate',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Completion',
				groupTitle: 'Completion',
				displayOrder: 11,
				getter: (x) => x.endDate,
				setter: (x, y) => x.endDate = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Performance Monitoring',
				placeholder: null,
				key: 'notes',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Notes',
				groupTitle: 'Notes',
				displayOrder: 8,
				getter: (x) => x.notes,
				setter: (x, y) => x.notes = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Performance Monitoring',
				placeholder: null,
				key: 'siteNotes',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Site Notes',
				groupTitle: 'Site Notes',
				displayOrder: 9,
				getter: (x) => x.siteNotes,
				setter: (x, y) => x.siteNotes = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Compass Declination',
				placeholder: null,
				key: 'compassDeclination',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'General',
				groupTitle: 'General',
				displayOrder: 6,
				getter: (x) => x.compassDeclination,
				setter: (x, y) => x.compassDeclination = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'BooleanViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					suffix: "º",
				}
			},
			{
				title: 'otherStaffMembers',
				placeholder: null,
				key: 'otherStaffMembers',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.otherStaffMembers,
				setter: (x, y) => x.otherStaffMembers = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(100),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Is Complete?',
				placeholder: null,
				key: 'isComplete',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Completion',
				groupTitle: 'Completion',
				displayOrder: 9,
				getter: (x) => x.isComplete,
				setter: (x, y) => x.isComplete = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Estimated Hours Spent',
				placeholder: null,
				key: 'estimatedHours',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Completion',
				groupTitle: 'Completion',
				displayOrder: 12,
				getter: (x) => x.estimatedHours,
				setter: (x, y) => x.estimatedHours = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					suffix: "hrs",
				}
			},
			{
				title: 'Finalized By',
				placeholder: null,
				key: 'finalizedBy',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.finalizedBy,
				setter: (x, y) => x.finalizedBy = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Finalized Date',
				placeholder: null,
				key: 'finalizedDate',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.finalizedDate,
				setter: (x, y) => x.finalizedDate = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Fulcrum Record ID',
				placeholder: null,
				key: 'fulcrumId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.fulcrumId,
				setter: (x, y) => x.fulcrumId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(36),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Fulcrum App ID',
				placeholder: null,
				key: 'fulcrumAppId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.fulcrumAppId,
				setter: (x, y) => x.fulcrumAppId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(36),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deletedKey',
				placeholder: null,
				key: 'deletedKey',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deletedKey,
				setter: (x, y) => x.deletedKey = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class ModelingEvent extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
